import React from 'react';

const OccultAltisonantLogo: React.FC<{ darkMode: boolean }> = ({ darkMode }) => {
  // Color scheme
  const primaryColor = "currentColor";
  const accentColor = darkMode ? "#1F2937" : "white";
  const strokeColor = darkMode ? "white" : "black";
  
  return (
    <svg className="w-16 h-16" viewBox="0 0 300 300">
  
  <circle cx="150" cy="150" r="120" fill="none" stroke={strokeColor} stroke-width="2" />
  <circle cx="150" cy="150" r="100" fill="none" stroke={strokeColor} stroke-width="1.5" />
  <circle cx="150" cy="150" r="80" fill="none" stroke={strokeColor} stroke-width="1" />
  <circle cx="150" cy="150" r="25" fill={accentColor} />
  <circle cx="150" cy="150" r="15" fill={strokeColor} />
  <circle cx="150" cy="150" r="8" fill={accentColor} />
  
  
  <g stroke={strokeColor} stroke-width="1">
    
    <line x1="150" y1="30" x2="150" y2="270" />
    <line x1="30" y1="150" x2="270" y2="150" />
    <line x1="79" y1="79" x2="221" y2="221" />
    <line x1="79" y1="221" x2="221" y2="79" />
    
    
    <path d="M 125,125 Q 115,100 105,125 Q 95,150 85,125" fill="none" stroke={strokeColor} stroke-width="1.5" />
    <path d="M 175,125 Q 185,100 195,125 Q 205,150 215,125" fill="none" stroke={strokeColor} stroke-width="1.5" />
    <path d="M 125,175 Q 115,200 105,175 Q 95,150 85,175" fill="none" stroke={strokeColor} stroke-width="1.5" />
    <path d="M 175,175 Q 185,200 195,175 Q 205,150 215,175" fill="none" stroke={strokeColor} stroke-width="1.5" />
  </g>
  
  
  <g>
    
    <circle cx="150" cy="30" r="22" fill="#1a1a1a" />
    <polygon points="150,18 160,38 140,38" fill="white" />
    
    
    <circle cx="270" cy="150" r="22" fill="#1a1a1a" />
    <text x="270" y="157" font-family="Arial, sans-serif" font-size="24" fill="white" text-anchor="middle">Σ</text>
    
    
    <circle cx="150" cy="270" r="22" fill="#1a1a1a" />
    <path d="M 138,270 Q 145,262 150,270 Q 155,278 162,270" stroke="white" stroke-width="2.5" fill="none" />
    
    
    <circle cx="30" cy="150" r="22" fill="#1a1a1a" />
    <text x="30" y="158" font-family="Arial, sans-serif" font-size="24" fill="white" text-anchor="middle">δ</text>
  </g>
  
  
  <g opacity="0.15">
    <path d="M 70,110 L 90,100 L 110,115 L 130,95" stroke="#4dabf7" stroke-width="1.5" fill="none" /> 
    <path d="M 170,90 L 190,105 L 210,95 L 230,110" stroke="#40c057" stroke-width="1.5" fill="none" /> 
    <path d="M 90,190 L 110,180 L 130,200 L 150,185" stroke="#ff922b" stroke-width="1.5" fill="none" /> 
  </g>
</svg>
  );
};

export default OccultAltisonantLogo;